import { DeepPartial } from 'utility-types';
import {
  Record,
  String as RTString,
  Number as RTNumber,
  Array as RTArray,
  Static,
  Partial
} from 'runtypes';
import { PrimaryCustomer } from '../customer';
import { ExistingAccount } from '../investment';

export const ContributoryApplication = Record({
  customer: PrimaryCustomer,
  currentYearAmount: RTNumber,
  existingAccounts: RTArray(ExistingAccount).Or(RTArray(Record({}))),
  newInvestments: RTArray(
    Partial({
      ticker: RTString,
      trpCode: RTString,
      fundingDetails: RTArray(
        Partial({
          fundingAmount: RTNumber,
          contributionYearType: RTString
        })
      )
    })
  ),
  investmentMethod: RTString,
  priorYearAmount: RTNumber,
  profileApplicationID: RTString,
  iraAccountType: RTString,
  termsIDs: RTArray(RTString),
  deviceToken: RTString
});

export type StaticContributoryApplication = Static<
  typeof ContributoryApplication
>;
export type OptionalStaticContributoryApplication = DeepPartial<
  StaticContributoryApplication
>;
